import { render, staticRenderFns } from "./ContractorPostingsTabs.vue?vue&type=template&id=7d458f20&scoped=true"
import script from "./ContractorPostingsTabs.vue?vue&type=script&lang=ts"
export * from "./ContractorPostingsTabs.vue?vue&type=script&lang=ts"
import style0 from "./ContractorPostingsTabs.vue?vue&type=style&index=0&id=7d458f20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d458f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d458f20')) {
      api.createRecord('7d458f20', component.options)
    } else {
      api.reload('7d458f20', component.options)
    }
    module.hot.accept("./ContractorPostingsTabs.vue?vue&type=template&id=7d458f20&scoped=true", function () {
      api.rerender('7d458f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jobboard/ContractorPostingsTabs.vue"
export default component.exports